module.exports = __webpack_public_path__ + "3c5fda212c2dbed0acf38b8644e91b57.svg";